var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',_vm._b({model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-chip-group',_vm.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }